import React from 'react';
import cx from 'classnames';

const STEPS = [
  { key: 'business', label: 'Business & Billing', match: ['identity', 'billing'] },
  { key: 'sign', label: 'Sign', match: ['sign'] },
  { key: 'card', label: 'Payment', match: ['card'] },
];

function StepIndicator({ current }) {
  const currentIndex = STEPS.findIndex(s => s.match.includes(current));

  return (
    <ol className="signup-steps" aria-label="Signup progress">
      {STEPS.map((step, index) => (
        <React.Fragment key={step.key}>
          {index > 0 && (
            <li
              className={cx('step-line', { done: index <= currentIndex })}
              aria-hidden="true"
            />
          )}
          <li
            className={cx('step-item', {
              active: index === currentIndex,
              done: index < currentIndex,
            })}
            aria-current={index === currentIndex ? 'step' : undefined}>
            <div className="step-dot" aria-hidden="true">
              {index < currentIndex ? '✓' : index + 1}
            </div>
            <span className="step-label">{step.label}</span>
          </li>
        </React.Fragment>
      ))}
    </ol>
  );
}

export default StepIndicator;
